var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowseIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0739 1.20898H3.81283C3.30199 1.20898 2.81208 1.41191 2.45086 1.77313C2.08965 2.13434 1.88672 2.62426 1.88672 3.13509V22.3962C1.88672 22.907 2.08965 23.3969 2.45086 23.7581C2.81208 24.1193 3.30199 24.3223 3.81283 24.3223H23.0739C23.5847 24.3223 24.0746 24.1193 24.4359 23.7581C24.7971 23.3969 25 22.907 25 22.3962V3.13509C25 2.62426 24.7971 2.13434 24.4359 1.77313C24.0746 1.41191 23.5847 1.20898 23.0739 1.20898Z",
    stroke: "#FE4A23",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8752 6.9873L7.02295 18.5439M18.5796 18.5439V13.4077M18.5796 10.1975V9.55545M10.8752 6.9873L14.7274 18.5439M8.30702 14.6917H13.4433",
    stroke: "#FE4A23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseIcon01);
export default __webpack_public_path__ + "static/media/browse-icon-01.a3ec6c85d5d3e31e92cd9e0980029d5c.svg";
export { ForwardRef as ReactComponent };